import { render } from "./JellyTriangle.vue?vue&type=template&id=619a871c&scoped=true"
import script from "./JellyTriangle.vue?vue&type=script&lang=js"
export * from "./JellyTriangle.vue?vue&type=script&lang=js"

import "./JellyTriangle.vue?vue&type=style&index=0&id=619a871c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619a871c"]])

export default __exports__